import { environment } from '../../environments/environment';
import {
  ENDPOINT_UPCOMING_PAYMENTS,
  ENDPOINT_PENDING_PAYMENTS,
  ENDPOINT_HISTORIC_PAYMENTS,
  ENDPOINT_LOANS,
  ENDPOINT_LOAN_INFO,
  ENDPOINT_LOAN_STATEMENTS,
  ENDPOINT_PAYMENTS,
  ENDPOINT_RECURRING_PAYMENTS,
  ENDPOINT_BANK_LOOKUP,
  ENDPOINT_LOGIN,
  ENDPOINT_LOGOUT,
  ENDPOINT_VALIDATE,
  ENDPOINT_REFRESH,
  ENDPOINT_REGISTER,
  ENDPOINT_PASSWORD_FORGOT,
  ENDPOINT_PASSWORD_RESET,
  ENDPOINT_PASSWORD_TOKEN,
  ENDPOINT_STATEMENT_DOWNLOAD,
  ENDPOINT_WALLETS,
  ENDPOINT_PASSWORD_CHANGE,
  ENDPOINT_USERNAME_RECOVER,
  ENDPOINT_IPOSPAY_FTD_TOKEN,
  ENDPOINT_IPOSPAY_DEBIT
} from '../constants/endpoints';

// Wallet API URLs
export const getWalletsUrl = (): string => {
  return `${environment.API_BASE_URL}${ENDPOINT_WALLETS}`;
};

// Loan API URLs
export const getLoansUrl = (): string => {
  return `${environment.API_BASE_URL}${ENDPOINT_LOANS}`;
};

export const getLoanDetailsUrl = (loanId: string): string => {
  return `${environment.API_BASE_URL}${ENDPOINT_LOAN_INFO.replace('{loanId}', loanId)}`;
};

export const getStatementsUrl = (loanId: string): string => {
  return `${environment.API_BASE_URL}${ENDPOINT_LOAN_STATEMENTS.replace('{loanId}', loanId)}`;
};

export const getStatementDownloadUrl = (loanId: string, rowId: string): string => {
  return `${environment.API_BASE_URL}${ENDPOINT_STATEMENT_DOWNLOAD.replace('{loanId}', loanId).replace('{rowId}', rowId.toString())}`;
};

// Payment API URLs
export const getPaymentsUrl = (): string => {
  return `${environment.API_BASE_URL}${ENDPOINT_PAYMENTS}`;
};

export const getRecurringPaymentUrl = (recurringPaymentId: string): string => {
  return `${environment.API_BASE_URL}${ENDPOINT_RECURRING_PAYMENTS
    .replace('{recurringPaymentId}', recurringPaymentId)}`;
};

export const getHistoricPaymentsUrl = (loanId: string): string => {
  return `${environment.API_BASE_URL}${ENDPOINT_HISTORIC_PAYMENTS.replace('{loanId}', loanId)}`;
};

export const getUpcomingPaymentsUrl = (loanId: string): string => {
  return `${environment.API_BASE_URL}${ENDPOINT_UPCOMING_PAYMENTS.replace('{loanId}', loanId)}`;
};

export const getPendingPaymentsUrl = (loanId: string): string => {
  return `${environment.API_BASE_URL}${ENDPOINT_PENDING_PAYMENTS.replace('{loanId}', loanId)}`;
};

// Bank API URLs
export const getBanksUrl = (): string => {
  return `${environment.API_BASE_URL}${ENDPOINT_WALLETS}`;
}

// Auth API URLs
export const getLoginUrl = (): string => {
  return `${environment.API_AUTH_BASE_URL}${ENDPOINT_LOGIN}`;
};

export const getLogoutUrl = (): string => {
  return `${environment.API_AUTH_BASE_URL}${ENDPOINT_LOGOUT}`;
};

export const getValidateUrl = (): string => {
  return `${environment.API_AUTH_BASE_URL}${ENDPOINT_VALIDATE}`;
};

export const getRefreshUrl = (): string => {
  return `${environment.API_AUTH_BASE_URL}${ENDPOINT_REFRESH}`;
};

export const getRegisterUrl = (): string => {
  return `${environment.API_AUTH_BASE_URL}${ENDPOINT_REGISTER}`;
};

// Password API URLs
export const getPasswordForgotUrl = (): string => {
  return `${environment.API_AUTH_BASE_URL}${ENDPOINT_PASSWORD_FORGOT}`;
};

export const getPasswordResetUrl = (): string => {
  return `${environment.API_AUTH_BASE_URL}${ENDPOINT_PASSWORD_RESET}`;
};

export const getPasswordTokenUrl = (token: string): string => {
  return `${environment.API_AUTH_BASE_URL}${ENDPOINT_PASSWORD_TOKEN.replace('{token}', token)}`;
};

export const getPasswordChangeUrl = (): string => {
  return `${environment.API_AUTH_BASE_URL}${ENDPOINT_PASSWORD_CHANGE}`;
};

export const getUsernameRecoverUrl = (): string => {
  return `${environment.API_AUTH_BASE_URL}${ENDPOINT_USERNAME_RECOVER}`;
};

export const getFtdTokenUrl = (): string => {
  return `${environment.API_BASE_URL}${ENDPOINT_IPOSPAY_FTD_TOKEN}`;
};

export const getIpospayDebitUrl = (): string =>
  `${environment.API_BASE_URL}${ENDPOINT_IPOSPAY_DEBIT}`;